import { DatePipe } from '@angular/common'
import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { CentralContentService } from 'src/app/services/content/central-content.service'

import { Overview } from '../../overview.model'

@Component({
  selector: 'performance',
  templateUrl: './performance.component.html',
  styleUrls: ['./performance.component.scss'],
  providers: [],
})
export class PerformanceComponent implements OnInit {
  @Input()
  overviewModel: Overview
  @ViewChild('simpleDialogContent') simpleDialogContent: TemplateRef<any>

  dialogTitle: string
  dialogBody: string
  compoundYield: string
  public SecyieldFlag = false
  fundDefinition = 'fund-definitions'
  datePipe: any
  aemContentSub: Subscription
  constructor(
    private readonly viewContainer: ViewContainerRef,
    private readonly centralContentService: CentralContentService,
  ) {
    this.datePipe = new DatePipe('en-US')
  }

  ngOnInit() {
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }

  parseAEMContent(content) {
    this.compoundYield = this.centralContentService.getContentByBody(
      'fund_definitions_compound_yield',
      content,
    ).contentValue
  }

  public setDialogInfo(longName = '', noteText = '', notecode = '') {
    this.dialogTitle = longName
    this.dialogBody = notecode.concat(' - ').concat(noteText)
    if (this.dialogTitle === 'Compound yield') {
      this.SecyieldFlag = true
      this.dialogBody = this.compoundYield
    }
  }
}
